import N8nExternalLink from './ExternalLink.vue';

export default N8nExternalLink;
